import React from 'react';
import { NavLink } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const projects = [
    {
        title1: 'Industrial Project',
        slug : 'industrial',
        title2: 'Production Facility!',
        image: require('./../../images/project/pic1.webp'),
        description: 'Construction has begun on our new factory and office building. The factory will feature advanced technology, while the office will offer a modern workspace. We are committed to delivering these projects with top-notch quality and efficiency.',
    },
    {
        title1: 'Residential Project',
        slug: 'residential-villas',
        title2: 'Residential Villa',
        image: require('./../../images/project/pic2.webp'),
        description: 'You will find yourself working that result partnership in an incredible Experience, and an end products that is the best.',
    },
    {
        title1: 'Infrastructural Project',
        title2: 'Water Filtration Plant',
        slug: 'infrastructure',
        image: require('./../../images/project/pic3.webp'),
        description: 'The water filtration plant uses cutting-edge technology to filter water with high suspended solids, ensuring safe, clean water for domestic use. it addresses water contamination effectively.',
    },
    {
        title1: 'Fit-Outs Project',
        title2: 'Interior Fitouts',
        slug: 'fit-outs',
        image: require('./../../images/project/pic4.webp'),
        description: 'Interior fitouts entail the careful arrangement of interior design components to optimize functionality and aesthetics. This includes selecting and installing fixtures, fittings, and furnishings to create a cohesive environment.',
    },
    {
        title1: 'Engineering Survey',
        title2: 'Topography',
        slug: 'Engineering Survey',
        image: require('./../../images/project/pic5.webp'),
        description: 'A topographical survey maps natural and man-made features of land, including elevation, contours, vegetation, water bodies, and structures. Its crucial for urban planning, engineering, and environmental assessments, offering precise data for informed decision-making.',
    }

]

var bnr1 = require('./../../images/background/bg-1.png');

class Projects1 extends React.Component {
    render() {
        const options = {
            loop:false,
            autoplay:true,
            nav:true,
            dots: false,	
            margin:30,
            navText: ['<i className="fa fa-long-arrow-left"></i>', '<i className="fa fa-long-arrow-right"></i>'],
            responsive:{
                0:{
                    items:1,
                },
                1400:{
                    items:1
                }		
            }
        };
        return (
            <>
                <div className="section-full project-1-outer-main p-t80">
                    <div className="container">
                        <div className="wt-separator-two-part bg-white">
                            <div className="row wt-separator-two-part-row">
                                <div className="col-lg-6 col-md-6 wt-separator-two-part-left">
                                    {/* TITLE START*/}
                                    <div className="section-head left wt-small-separator-outer">
                                        <div className="wt-small-separator site-text-primary">
                                            <div className="sep-leaf-left" />
                                            <div>Projects for inspirations</div>
                                            <div className="sep-leaf-right" />
                                        </div>
                                        <h2>We've completed numerous projects. Explore some of them here</h2>
                                    </div>
                                    {/* TITLE END*/}
                                </div>
                                <div className="col-lg-6 col-md-6 wt-separator-two-part-right text-left">
                                    <p>We are delighted to share a carefully curated collection of projects completed by Skyland Construction. As a company dedicated to achieving excellence in every project, we take great pride in presenting our diverse portfolio. Each completed project serves as a testament to our expertise, unwavering dedication, and profound passion for construction.</p>

                                    <NavLink to="/projects" className="site-button-link">Read More</NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="project-1-outer-section bg-gray bg-center" style={{ backgroundImage: "url(" + bnr1 + ")" }}>
                        <div className="container">
                            {/* PROJECT SLIDER START */}
                            <div className="section-content">
                                <div className="project-1-outer clearfix">
                                    <div className="project-1-left">
                                        <div className="crane-image-section">
                                            <img src={require('./../../images/crane.webp')} alt="" />
                                        </div>
                                    </div>
                                    <div className="project-1-right">
                                        <OwlCarousel className="owl-carousel project-1-slider owl-btn-top-right long-arrow-next-prev" {...options}>
                                            {projects.map((item, index) => (
                                                <div key={index} className="item">
                                                    <div className="pproject-1-inner-block clearfix">
                                                        <div className="project-1-inner-media">
                                                            <div className="project-1-inner-pic">
                                                                <img src={item.image} alt="" />
                                                            </div>
                                                        </div>
                                                        <div className="project-1-inner-info">
                                                            <h4 className="site-text-primary">{item.title1}</h4>
                                                            <h3 className="wt-title">{item.title2}</h3>
                                                            <p>{item.description}</p>
                                                            <NavLink to={"/projects?type="+item.slug} className="site-button site-btn-effect">More Detail</NavLink>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </OwlCarousel>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default Projects1;